(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialise = (root = document) => {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('rr-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    root.querySelectorAll('.rr-reveal').forEach(element => {
      if (element.getBoundingClientRect().top > window.innerHeight) {
        element.classList.add('rr-ready');
        observer.observe(element);
      }
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
